module.exports = __webpack_public_path__ + "img/backHover.bb092a80.png";